module.exports = __webpack_public_path__ + "static/media/brawl_stars_sandy2.89f480ec.png";